/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2022
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import GenericClientUtils from './GenericClientUtils';
import ModuleUtils from './ModuleUtils';
//@import com/ibm/bi/platform/moser/client/utils/GenericClientUtils (loadtime) // superclass
//@import com/ibm/bi/platform/moser/client/utils/ModuleUtils (runtime) // add

/**
 * Utility for WhatIfModel object manipulation
 */
export default class WhatIfModelUtil extends GenericClientUtils{

	/**
	 * @param {Module} module
	 * @param {String} identifier
	 */
	removeWhatIfModel(module, identifier) {
		for (var __i_enFor0 = 0, __exp_enFor0 = module.getWhatIfModel(), __len_enFor0 = __exp_enFor0.length;
				__i_enFor0 < __len_enFor0; ++__i_enFor0) {
			var model = __exp_enFor0[__i_enFor0];
			if (model.getIdentifier() == identifier) {
				module.removeWhatIfModel(model);
				return;
			}
		}
	}

	/**
	 * Create and insert new whatIf model object /make sure the new object is inserted into the right spot - index 0 ??
	 * @param {Module} module
	 * @param {Object} modelDefinition
	 * @return {WhatIfModel}
	 * @throws {IOException} IOException
	 */
	createWhatIfModel(module, modelDefinition, label) {
		if (!modelDefinition) {
			return null;
		}
		var whatIfModel = this.objectFactory.createWhatIfModel();
		whatIfModel.setWhatIfDefinition(JSON.stringify(modelDefinition));
		whatIfModel.setLabel(label);
		ModuleUtils.add(whatIfModel, module, -1, this.objectFactory, false);
		return whatIfModel;
	}

	/**
	 * Created a calculation copy with a new id and add it to the whatIf model. Return new calculation copy with new id
	 * @param {WhatIfModel} whatIfModel model to add copy of the calculation to
	 * @param {Calculation} calculation original calculation to be copied
	 * @return {Calculation}  new calculation copy
	 * @throws {CloneNotSupportedException} CloneNotSupportedException
	 */
	createCalculationCopy(whatIfModel, calculation) {
		var clone = this.createCopy(whatIfModel, calculation);
		whatIfModel.addCalculation(clone);
		return clone;
	}

	/**
	 * Update model definition
	 * @param {WhatIfModel} whatIfModel whatIf model object
	 * @param {Object} definition new definition
	 * @throws {IOException} IOException
	 */
	updateWhatIfModelDef(whatIfModel, definition) {
		if (whatIfModel && definition) {
			whatIfModel.setWhatIfDefinition(JSON.stringify(definition));
		}
	}

	/**
	 * Return JSONObject whatIf model definition. Throw exception, if definition can not be parsed into json object
	 * @param {WhatIfModel} whatIfModel WhatIfModel object
	 * @return {Object}  whatIf model definition JSON object
	 * @throws {IOException} IOException
	 */
	getWhatIfModelDef(whatIfModel) {
		var definition = whatIfModel.getWhatIfDefinition();
		return JSON.parse(definition);
	}

	/**
	 * Add new calculation with expression and the label to the whatIf model
	 * @param {WhatIfModel} whatIfModel whatIf model object
	 * @param {String} calculationLabel calculation label
	 * @param {String} expression calculation expression
	 * @param {Object} calc_properties calculation properties as json object
	 * @return {Calculation}  new calculation
	 */
	addCalculation(whatIfModel, calculationLabel, expression, calc_properties) {
		var calculation = this.objectFactory.createCalculation();
		calculation.setLabel(calculationLabel);
		calculation.setExpression(expression);
		if (calc_properties) {
			for (var __i_enFor0 = 0, __exp_enFor0 = Object.keys(calc_properties), __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var key = __exp_enFor0[__i_enFor0];
				var value = calc_properties[key];
				var pair = this.objectFactory.createPropertyType();
				pair.setName(key.toString());
				pair.setValue(value.toString());
				calculation.addProperty(pair);
			}
		}
		ModuleUtils.add(calculation, whatIfModel, -1, this.objectFactory, false);
		return calculation;
	}

	//constructor() 
}


// WEBPACK FOOTER //
// ./src/generated/WhatIfModelUtil.js